// The file contents for the production environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  local: false,
  version: '1.1.20(2019/09/17)',
  // baseUrl: 'https://mobile-prod.mrstream.jp/v1/daigo-wh.co.jp',
  baseUrl: 'https://api.wms.seaos.jp/v1/',
  bucketUrl: 'https://batch-prod.wms.seaos.jp',
  imagePath: 'https://mobile-prod.wms.seaos.jp/images/',
  pdfPath: 'https://dl.wms.seaos.jp/',
  serviceCode:'',
  gridLocale: {
    // standard menu
    copy: 'コピー',
    copyWithHeaders: 'ヘッダーもコピー',
    paste: 'ペースト',
    export: 'エクスポート',
    csvExport: 'チェックしたもののみCSVエクスポート',
    csvAllExport: 'すべてCSVエクスポート',
    excelExport: 'すべてExcelエクスポート',
    noRowsToShow: 'データが存在しません.もしくは、荷主が選択されていません.',
    // for filter panel
    page: 'ページ',
    more: 'もっと',
    to: 'から',
    of: ' / ',
    next: '次',
    last: '最後',
    first: '最初',
    previous: '前',
    // for number filter and text filter
    filterOoo: 'フィルタ...',
    // for number filter
    equals: '等しい',
    notEqual: '等しくない',
    lessThan: '未満',
    greaterThan: 'より大きい',
    // for text filter
    contains: '含む',
    notContains: '含まない',
    startsWith: '〜で始まる',
    endsWith: '〜で終わる',
  }
};



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/environments/environment.ts